import { isBrowser } from 'Shared/device-type';
import isStartPage from '../Start/Pages/Start/current-page-is-start';
import isCheckoutPage from '../Checkout/Pages/Checkout/current-page-is-checkout';
import { isSearchPage } from '../Search/Pages/Search/current-page-is-search';
import { isCategoryPageType } from '../Category/Commerce/Components/current-page-is-category';
import isOrderConfirmation from '../Checkout/Pages/OrderConfirmation/current-page-is-order-confirmation';
import { addEcommerceEventToDataLayer, addGa4EventToDataLayer, pushGa4Event } from './ga4DataLayer';
import { getGa4ItemListReferrel } from './ga4ItemListReferral';
export * from './ga4DataLayer';
export * from './ga4ItemListReferral';
export * from './viewItemListCardTracker';
let quickSearchDebounceTimer = null;
let lastTrackedQuickSearchTerm = null;
const GA4_QUICKSEARCH_DELAY = 1800;
let updateCategorydebounceTimeout;
let updateCategorydebounceDelay = 1000 * 3;
let lastPath = null;
const recomandationZoneProductId = 'recomandationZoneProductId';
const ODP_LOGIN_DELAY = 1000;
function addGa4CommerceToDataLayerOnPageLoad(events, selectedVariantCode, state) {
    var beginCheckoutTriggered = sessionStorage.getItem("beginCheckoutTriggered");
    if (beginCheckoutTriggered !== "true" || getGa4ItemListReferrel() !== "Checkout") {
        if ("begin_checkout" in events) {
            addEcommerceEventToDataLayer(events[String("begin_checkout")]);
            sessionStorage.setItem("beginCheckoutTriggered", "true");
        }
    }
    if ('view_item' in events) {
        const viewItemEvents = events[String('view_item')];
        const viewItemEvent = viewItemEvents[selectedVariantCode] || Object.keys(viewItemEvents).map(code => viewItemEvents[code])[0];
        if (!!viewItemEvent) {
            addEcommerceEventToDataLayer(viewItemEvent);
        }
    }
    if ('purchase' in events) {
        addEcommerceEventToDataLayer(events[String('purchase')]);
    }
    if ('login' in events) {
        !!window.dataLayer && window.dataLayer.push(events[String('login')]);
    }
}
export function getSearchEngineForTracking(searchApiVariation) {
    return searchApiVariation === "graph" ? "graph" : "esales";
}
export function trackGa4SearchToDataLayer(searchTerm, totalItems, products = null, searchApiVariation) {
    if (!searchTerm)
        return;
    var topSearchResults = getTopSearchResultsForSearch(products, 8);
    window.dataLayer.push({
        event: 'view_search_results',
        search_term: searchTerm,
        number_of_search_results: totalItems,
        search_engine: getSearchEngineForTracking(searchApiVariation),
        top_search_results: topSearchResults
    });
}
export function setSessionStorageGa4SearchTrackedFlag(value = "false") {
    sessionStorage.setItem("ga4SearchTracked", value);
}
export function trackGa4QuickSearch(searchTerm, totalItems, topSearchResults = [], searchApiVariation) {
    if (!searchTerm)
        return;
    window.dataLayer.push({
        event: 'view_quicksearch_results',
        search_term: searchTerm,
        number_of_search_results: totalItems,
        search_engine: getSearchEngineForTracking(searchApiVariation),
        top_search_results: topSearchResults
    });
}
export function addGa4SearchToDataLayer(searchTerm) {
    window.dataLayer.push({
        'event': 'search',
        'searchTerm': searchTerm
    });
}
export function addGa4QuickSearchToDataLayer(searchTerm) {
    window.dataLayer.push({
        'event': 'quicksearch',
        'searchTerm': searchTerm
    });
}
export function debounceQuickSearchTracking(searchTerm, resultCount, product, searchApiVariation) {
    if (lastTrackedQuickSearchTerm === searchTerm)
        return;
    if (quickSearchDebounceTimer) {
        clearTimeout(quickSearchDebounceTimer);
    }
    var topSearchResults = getTopSearchResultsForSearch(product, 5);
    quickSearchDebounceTimer = window.setTimeout(() => {
        trackGa4QuickSearch(searchTerm, resultCount, topSearchResults, searchApiVariation);
        lastTrackedQuickSearchTerm = searchTerm;
    }, GA4_QUICKSEARCH_DELAY);
}
function getTopSearchResultsForSearch(products, limit = 8) {
    if (!products || !products.length)
        return [];
    return products.slice(0, limit).map((product) => ({
        item_name: product.title,
        item_id: product.code,
    }));
}
export function initTagManager() {
    window.dataLayer = window.dataLayer || [];
}
export function addToImbox(action) {
    if (isBrowser()) {
        try {
            console.log("[IMBOX] Adding action:", action);
            console.log("[IMBOX] _imbox before push:", window._imbox);
            window._imbox.push(action);
            console.log("[IMBOX] _imbox after push:", window._imbox);
        }
        catch (error) {
            console.error("[IMBOX] Failed to add action:", action, error);
            window.newrelic && window.newrelic.noticeError(error);
        }
    }
}
export function updateUserNameOnImbox(currentUser) {
    if (currentUser.isLoggedIn) {
        addToImbox(['changeName', `${currentUser.fullName} (${currentUser.customerId})`]);
    }
    else {
        addToImbox(['changeName', 'Ej inloggad']);
    }
}
export function initImbox() {
    window._imbox = window._imbox || [];
}
export const ODPTrackingActions = {
    'ADD_TO_CART': 'add_to_cart',
    'REMOVE_FROM_CART': 'remove_from_cart',
    'DETAIL': 'detail'
};
export function updateODPTracking(code, action) {
    !!code && !!action && setTimeout(() => {
        !!window["zaius"] && window["zaius"].event("product", {
            action: action,
            product_id: `${code}`
        });
    });
}
export function updateODPTrackingMinicart() {
    setTimeout(() => {
        !!window["zaius"] && window["zaius"].event("checkout", {
            action: 'start'
        });
    });
}
export function updateODPTrackingSearchPage(searchTerm) {
    !!searchTerm && setTimeout(() => {
        !!window["zaius"] && window["zaius"].event("navigation", {
            action: 'search',
            search_term: searchTerm,
        });
    });
}
export function updateODPTrackingSearchResultProductClick(searchTerm, url) {
    !!searchTerm && !!url && setTimeout(() => {
        !!window["zaius"] && window["zaius"].event("search", {
            action: 'click',
            search_term: searchTerm,
            campaign: `Content Result Click - - Search Term: ${searchTerm}`,
            value: url
        });
    });
}
export function updateODPTrackingLogin(customer) {
    !!customer && !!(customer === null || customer === void 0 ? void 0 : customer.customerNumber);
    setTimeout(() => {
        !!window["zaius"] &&
            window["zaius"].event("account", {
                action: "login",
                customer_number: customer.customerNumber,
                email: customer.email,
                alcohol_license: customer.alcoholLicense,
                business_segment_id: customer.businessSegmentId,
                store_id: customer.storeId,
                visible_articles: customer.visibleArticles,
                type_of_business: customer.typeOfBusiness,
                type_of_kitchens: customer.typeOfKitchens,
                equipment_customer: customer.equipmentCustomer,
                agreement_customer_id: customer.agreementCustomerId,
                quotation_id: customer.customerQuotationId,
                customer_group_id: customer.customerGroupId
            });
    }, ODP_LOGIN_DELAY);
}
export function logoutGtm(method, customerId, customerType) {
    const action = {
        event: "logout",
        params: {
            method: method,
            customer_id: customerId !== null && customerId !== void 0 ? customerId : null,
            customer_type: customerType !== null && customerType !== void 0 ? customerType : null
        }
    };
    pushGa4Event(action);
}
export function deliveryDateChange(changedDeliveryDate, customerId, customerType) {
    const action = {
        event: "change_delivery_date",
        params: {
            delivery_date: changedDeliveryDate,
            customer_id: customerId !== null && customerId !== void 0 ? customerId : null,
            customer_type: customerType !== null && customerType !== void 0 ? customerType : null
        }
    };
    pushGa4Event(action);
}
export function pageLoad(page, isDynamicPageLoad, state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const path = window.location.pathname;
    if (lastPath === path)
        return;
    lastPath = path;
    try {
        const user = state.currentUser.trackingUser;
        const action = {
            event: "virtual_page_view",
            params: {
                page_location: window.location.href,
                page_referrer: document.referrer || null,
                page_title: document.title || path,
                page_path: window.location.pathname,
                customer_id: (_a = user === null || user === void 0 ? void 0 : user.id) !== null && _a !== void 0 ? _a : null,
                page_load_type: isDynamicPageLoad ? "dynamic" : "hard",
                customer_type: (_b = user === null || user === void 0 ? void 0 : user.customerType) !== null && _b !== void 0 ? _b : null,
                ambition_code: (_c = user === null || user === void 0 ? void 0 : user.ambitionCode) !== null && _c !== void 0 ? _c : null,
                customer_type_code: (_d = user === null || user === void 0 ? void 0 : user.customerTypeCode) !== null && _d !== void 0 ? _d : null,
                orientation: (_e = user === null || user === void 0 ? void 0 : user.orientation) !== null && _e !== void 0 ? _e : null,
                potential: (_f = user === null || user === void 0 ? void 0 : user.potential) !== null && _f !== void 0 ? _f : null,
                customer_loyalty: (_g = user === null || user === void 0 ? void 0 : user.customerLoyalty) !== null && _g !== void 0 ? _g : null,
                customer_attributes: (_h = user === null || user === void 0 ? void 0 : user.customerAttributes) !== null && _h !== void 0 ? _h : null,
                customer_potential: (_j = user === null || user === void 0 ? void 0 : user.customerPontential) !== null && _j !== void 0 ? _j : null
            }
        };
        pushGa4Event(action);
        trackLogin(state);
        setTimeout(() => {
            !!window["zaius"] && window["zaius"].event("pageview");
        }, 100);
        const events = (_m = (_l = (_k = state.currentPage) === null || _k === void 0 ? void 0 : _k.trackingData) === null || _l === void 0 ? void 0 : _l.events) !== null && _m !== void 0 ? _m : [];
        if (Array.isArray(events)) {
            events.forEach((evt) => {
                pushGa4Event(evt);
            });
        }
        if (getGa4ItemListReferrel() !== "Checkout") {
            setAndRemoveRecommendationProductIds(null, 'remove');
        }
        let ga4EventObjects = !!state.currentPage.trackingData && state.currentPage.trackingData.ga4EventObjects;
        if (!!ga4EventObjects) {
            let code = String(state.product.selectedUnits[state.product.selectedUnits.length - 1]);
            if ((code == null || code == undefined || code == 'undefined') && (!!state.currentPage && !!state.currentPage.variants)) {
                code = state.currentPage.variants[0].code;
            }
            addGa4CommerceToDataLayerOnPageLoad(ga4EventObjects, code, state);
        }
        peeriusTracking(page, state);
    }
    catch (error) {
        window.newrelic && window.newrelic.noticeError(error);
        console.error(error);
    }
}
export function peeriusTracking(page, state) {
    try {
        if (!!state.currentUser.customerId) {
            const isSupplierSalesman = state.currentUser.isSupplierSalesman;
            if (!isSupplierSalesman) {
                if (!!isStartPage(page)) {
                    let baseJson = state.appShellData.peeriusTrackingData;
                    const json = {};
                    Object.assign(json, baseJson, { type: 'home' });
                    sendToPeerius(json);
                }
                else if (!!isCheckoutPage(page)) {
                    sendToPeerius(page.checkoutPageTrackingData);
                }
                else if (!!isSearchPage(page)) {
                    sendToPeerius(page.searchResultsPageTrackingData);
                }
                else if (!!isCategoryPageType(page)) {
                    sendToPeerius(page.categoryPageTrackingData);
                }
                else if (!!isOrderConfirmation(page)) {
                    sendToPeerius(page.orderConfirmationTrackingData);
                }
                else {
                    sendToPeerius(state.appShellData.peeriusTrackingData);
                }
            }
        }
    }
    catch (error) {
        console.error('Tracking error:', error);
    }
}
export function sendToPeerius(jsonData) {
    if (!!!jsonData)
        return;
    const json = encodeURIComponent(JSON.stringify(jsonData));
    if (!!!json)
        return;
    setTimeout(() => {
        if (!!window["Peerius"]) {
            window["Peerius"].sendAjax("rest.pagex?jd=" + json);
        }
    }, 1000);
}
;
export function sendRecommendationImpression(ids) {
    const peerius = window["Peerius"];
    const siteName = peerius === null || peerius === void 0 ? void 0 : peerius.siteName;
    if (!peerius || !siteName || ids.length === 0) {
        return;
    }
    peerius.sendAjax(`${siteName}/rec/shown.pagex?ids=${ids.join(",")}`);
}
export function promoClick(promo, index) {
    if (!!!promo)
        return;
    promo = handleIndex(promo, index);
    const action = {
        event: 'select_promotion',
        ecommerce: mapPromoToGa4Ecommerce(promo)
    };
    addGa4EventToDataLayer(action);
}
export function promoImpression(promo, index) {
    if (!!!promo)
        return;
    promo = handleIndex(promo, index);
    const action = {
        event: 'view_promotion',
        ecommerce: mapPromoToGa4Ecommerce(promo),
    };
    addGa4EventToDataLayer(action);
}
function mapPromoToGa4Ecommerce(promo, index) {
    return {
        promotion_id: promo.promotionId,
        promotion_name: promo.promotionName,
        creative_name: promo.creativeName,
        creative_slot: promo.locationId,
    };
}
function handleIndex(promo, index) {
    if (!!!promo.locationId)
        return promo;
    if (!promo.locationId.indexOf("{index}"))
        return promo;
    if (!!index)
        promo.locationId = promo.locationId.replace(/{index}/g, (index + 1).toString()).trim();
    else
        promo.locationId = promo.locationId.replace(/-*{index}/g, '').trim();
    return promo;
}
export function alternativeProductLinkClick(product) {
    const action = {
        event: "alternativa_varor",
        params: {
            event_category: "alternative_items_see_alternative_items",
            event_action: "Click",
            event_label: !!product ? product.title : "missing_title"
        }
    };
    pushGa4Event(action);
}
export function alternativeProductLinkImpression(product, outOfStock) {
    const action = {
        event: "alternativa_varor",
        params: {
            event_category: outOfStock ? "out_of_stock" : "ready_to_order",
            event_action: "view",
            event_label: !!product ? product.title : "missing_title"
        }
    };
    pushGa4Event(action);
}
export function recommendationsPanelImpression(recommendationPanel) {
    const action = {
        event: "recommendation_panel",
        params: {
            event_category: "rec_panel_native_category",
            event_action: "view",
            event_label: !!recommendationPanel ? recommendationPanel.title : "missing_title"
        }
    };
    pushGa4Event(action);
}
export function trackButtonClick(url, text) {
    const fullUrl = window.location.origin + url;
    const action = {
        event: "button_click",
        params: {
            element_url: fullUrl,
            element_text: text,
            page_referrer_list: sessionStorage.getItem("ga4ItemListReferrel")
        }
    };
    pushGa4Event(action);
}
export function recommendationsPanelLinkButtonClick(recommendationPanel) {
    const action = {
        event: "recommendation_panel",
        params: {
            event_category: "rec_panel_link_button",
            event_action: "click",
            event_label: !!recommendationPanel ? recommendationPanel.title + ' > ' + recommendationPanel.linkText : "missing_title"
        }
    };
    pushGa4Event(action);
}
export function updateCategoryFilterGA4Event(facets, itemCount) {
    if (updateCategorydebounceTimeout) {
        clearTimeout(updateCategorydebounceTimeout);
    }
    if (!facets) {
        return;
    }
    updateCategorydebounceTimeout = setTimeout(() => {
        const selectedFacets = getSelectedFacets(facets);
        const filters = selectedFacets.map((f) => ({
            filter1: f.displayName,
            filter2: f.selectedTexts,
        }));
        window.dataLayer.push({
            event: "category_filter",
            filters: filters,
            filter_results: itemCount,
        });
    }, updateCategorydebounceDelay);
}
function getSelectedFacets(facets) {
    return facets
        .map((facet) => {
        const selectedTexts = facet.facetValues
            .filter((fv) => fv.selected)
            .map((fv) => fv.text);
        return {
            displayName: facet.displayName,
            selectedTexts,
        };
    })
        .filter((f) => f.selectedTexts.length > 0);
}
function trackLogin(state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (!((_a = state.currentUser) === null || _a === void 0 ? void 0 : _a.isLoggedIn))
        return;
    const hasCookie = document.cookie.includes("login_started=true");
    if (!hasCookie)
        return;
    const user = state.currentUser.trackingUser;
    if (!user)
        return;
    updateODPTrackingLogin((_b = state.currentUser) === null || _b === void 0 ? void 0 : _b.customerTrackingODP);
    pushGa4Event({
        event: "login",
        params: {
            method: "Username/Password",
            customer_id: (_c = state.currentUser.customerId) !== null && _c !== void 0 ? _c : null,
            customer_type: (_d = user === null || user === void 0 ? void 0 : user.customerType) !== null && _d !== void 0 ? _d : null,
            ambition_code: (_e = user === null || user === void 0 ? void 0 : user.ambitionCode) !== null && _e !== void 0 ? _e : null,
            ambition_code_description: (_f = user === null || user === void 0 ? void 0 : user.ambitionCodeDescription) !== null && _f !== void 0 ? _f : null,
            customer_type_code: (_g = user === null || user === void 0 ? void 0 : user.customerTypeCode) !== null && _g !== void 0 ? _g : null,
            customer_type_code_description: (_h = user === null || user === void 0 ? void 0 : user.customerTypeCodeDescription) !== null && _h !== void 0 ? _h : null,
            direction_code: (_j = user === null || user === void 0 ? void 0 : user.directionCode) !== null && _j !== void 0 ? _j : null,
            direction_code_description: (_k = user === null || user === void 0 ? void 0 : user.directionCodeDescription) !== null && _k !== void 0 ? _k : null,
            potential: (_l = user === null || user === void 0 ? void 0 : user.potential) !== null && _l !== void 0 ? _l : null,
            customer_loyalty: (_m = user === null || user === void 0 ? void 0 : user.customerLoyalty) !== null && _m !== void 0 ? _m : null,
            customer_potential: (_o = user === null || user === void 0 ? void 0 : user.customerPontential) !== null && _o !== void 0 ? _o : null,
            customer_attributes: (_p = user === null || user === void 0 ? void 0 : user.customerAttributes) !== null && _p !== void 0 ? _p : null
        }
    });
    document.cookie = "login_started=; Max-Age=0; path=/";
}
export function setOptimizelyUserAttributes(customerSegment, customerGroupId, searchApiVariation) {
    if (!customerSegment) {
        return;
    }
    window["optimizely"] = window["optimizely"] || [];
    window["optimizely"].push({
        type: "user",
        attributes: {
            customer_segment: customerSegment,
            customer_group_id: customerGroupId,
            search_api_variation: searchApiVariation,
        },
    });
}
export function setAndRemoveRecommendationProductIds(data, action) {
    switch (action) {
        case "set":
            sessionStorage.setItem(recomandationZoneProductId, JSON.stringify(data));
            break;
        case "remove":
            sessionStorage.removeItem(recomandationZoneProductId);
            break;
    }
}
export function getRecommendationProductIds() {
    var saved = sessionStorage.getItem(recomandationZoneProductId);
    if (saved) {
        return JSON.parse(saved);
    }
    return null;
}
export function epiFormSubmission(formId, formName, fieldList) {
    const action = {
        event: "form_submit",
        form_id: formId,
        form_name: formName,
        params: fieldList,
    };
    window.dataLayer.push(action);
}
